export const appRequiresVerification = () => {
  return (
    process.env.REACT_APP_REQUIRES_ACCOUNT_VERIFICATION &&
    process.env.REACT_APP_REQUIRES_ACCOUNT_VERIFICATION === 'true'
  )
}
